import React, {
  createContext, useCallback, useMemo, useRef, useState,
} from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

export const LoadingContext = createContext({ isLoading: false, setLoading: () => null });

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export default function LoadingProvider({ children }) {
  const inFlightRequests = useRef(0);
  const [isLoading, setIsLoading] = useState(false);

  const setLoading = useCallback((newRequest) => {
    if (newRequest) {
      inFlightRequests.current += 1;
    } else {
      inFlightRequests.current -= 1;
    }
    setIsLoading(inFlightRequests.current > 0);
  }, []);

  const value = useMemo(() => ({ isLoading, setLoading }), [isLoading, setLoading]);
  return (
    <LoadingContext.Provider value={value}>
      <Backdrop
        sx={{ color: 'common.white', zIndex: 2000 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </LoadingContext.Provider>
  );
}
